import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { OperatoriService } from '../operatori.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { finalize, map } from 'rxjs';

@Component({
    selector: 'app-edit-operator',
    templateUrl: './edit-operator.component.html',
    styleUrls: ['./edit-operator.component.scss']
})
export class EditOperatorComponent implements OnInit {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    successIcon: string = environment.config.customNotifications.icons.success;

    stateRows: any[] = [];
    functiiOperator$: any = [];
    functiiSelected: any[] = [];
    serviciiIds: any[] = [];
    cerereTypeIds: any[] = [];
    dataPermisiuni: any;

    configData: any;

    token!: string;
    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditOperatorComponent>,
        private notificationService: NotificationService,
        private authService: AuthService,
        private operatorService: OperatoriService,
        private cdr: ChangeDetectorRef,
    ) {
        this.processToken();
        this.loadFunctiiOperator();
    }

    ngOnInit(): void {
        this.functiiOperator$.subscribe((data: any[]) => {
            this.stateRows = data.map(item => ({ ...item }));
        });
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.operatorService.setToken(token);
        });
    }

    submitForm() {
        console.log('not implemented yet');
    }

    updateCheckedList(item: any, isHeaderCheckbox: boolean = false) {
        let arrayToUpdate = isHeaderCheckbox ? this.serviciiIds : this.cerereTypeIds;

        if (item.checked) {
            if (!arrayToUpdate.includes(item.id)) {
                arrayToUpdate.push(item.id);
            }
        } else {
            const index = arrayToUpdate.indexOf(item.id);
            if (index > -1) {
                arrayToUpdate.splice(index, 1);
            }
        }

        this.configData.forEach((group: any) => {
            if (group.cereri_types.length > 0) {
                let totalItems = group.cereri_types.length;
                let selectedCount = group.cereri_types.filter((cerere: any) => this.cerereTypeIds.includes(cerere.id)).length;
                group.label = `${group.label.split('(')[0].trim()} (Selectate: ${selectedCount} / Total: ${totalItems})`;

                const correspondingRow = this.stateRows.find((row: any) => row.id === group.id);
                if (correspondingRow) {
                    correspondingRow.label = group.label;
                }
            }
        });

        if (isHeaderCheckbox) {
            // If it's a header checkbox, select/deselect all subitems without expanding/collapsing the panel
            item.cereri_types.forEach((cerere: any) => {
                cerere.checked = item.checked;
                this.updateCheckedList(cerere);
            });
            return;
        }
    }

    loadFunctiiOperator() {
        this.isLoading = true;
        this.functiiOperator$ = this.operatorService
            .permisiuniList(this.data.id_user)
            .pipe(
                map((results: any) => {
                    this.configData = results.data.config;
                    this.serviciiIds = results.data.operator_allocated.servicii;
                    this.cerereTypeIds = results.data.operator_allocated.cereri_types;

                    this.configData.forEach((group: any) => {
                        if (group.cereri_types.length > 0) {
                            let totalItems = group.cereri_types.length;
                            let selectedCount = group.cereri_types.filter((cerere: any) => this.cerereTypeIds.includes(cerere.id)).length;
                            group.label += ` (Selectate: ${selectedCount} / Total: ${totalItems})`;
                        }
                    });

                    return this.configData.map((item: any) => ({
                        ...item,
                        // name: item.label,
                        checked: this.serviciiIds.includes(item.id),
                        cereri_types: item.cereri_types.map((cerere: any) => ({
                            ...cerere,
                            name: cerere.label,
                            checked: this.cerereTypeIds.includes(cerere.id),
                        })),
                    }));
                }),
                finalize(() => {
                    this.isLoading = false;
                })
            );
    }

    updateUtilizatori() {
        this.isLoading = true;
        this.operatorService
            .postUpdateOperator(this.data.id_user, {
                cerereTypeIds: this.cerereTypeIds,
                serviciiIds: this.serviciiIds,
            })
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.success,
                        'Actualizare cu succes',
                        this.successIcon
                    );
                    this.closeDialog();
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
